import { PostCurrentStatu } from "./postStatus.model";

export class PostModel{
    postId: string;
    postDate: string;
    postEmailFrom: string;
    postEmailTo: string;
    postEmailCC: string;
    postEmailSubject: string;
    postEmailMessage: string;
    sentDateDate: string;
    recievedDate: string;
    postDossierId: string;
    postCurrentStatu: PostCurrentStatu
    postCreatedDate: string;
    postSendDate: string;
    postReceiveDate: string;
    postInactive: boolean; 
}